/**
 * Ảnh lấy từ khay nhớ tạm (Ctrl+V) — dùng chung cho ô soạn ghi chú đơn hàng
 * và ô soạn tin nhắn chat khách (CEO chốt 25/09/2026).
 */

/**
 * Đọc `items` trước rồi mới tới `files`: Safari cũ chỉ điền `items`, còn khi
 * người dùng copy một TỆP ảnh trong Finder/Explorer thì ngược lại — chỉ
 * `files` có. Lọc trùng theo danh tính đối tượng vì cùng một ảnh có thể xuất
 * hiện ở cả hai danh sách.
 *
 * Trả mảng rỗng khi khay không có ảnh nào; nơi gọi dựa vào đó để KHÔNG chặn
 * hành vi mặc định, giữ nguyên đường dán chữ.
 */
export function imagesFromClipboard(data: DataTransfer | null): File[] {
  if (!data) return [];
  const found: File[] = [];
  for (const item of Array.from(data.items ?? [])) {
    if (item.kind !== "file" || !item.type.startsWith("image/")) continue;
    const file = item.getAsFile();
    if (file) found.push(file);
  }
  for (const file of Array.from(data.files ?? [])) {
    if (file.type.startsWith("image/") && !found.includes(file)) found.push(file);
  }
  return found;
}
